
import { computed, onMounted, ref, reactive } from 'vue'
import { useStore } from 'vuex'
import Glide from '@glidejs/glide'


export default {
    name: 'ProductDetailImages',
    setup() {

        const store = useStore()
        let glide = ""
        let modalActiveState = ref(false)
        let imageSelectedForModal = reactive({
            url : undefined,
            alt : undefined 
        })

        const imageData = computed(() => store.state.productDetails.product_detail_image_data)

        // thumbnail scrolling
        const maxRoomForThumbnails = 5
        const showScrollUpButton = computed(()=> thumbnailsScrolledCount.value > 0)
        const showScrollDownButton = computed(()=>{
            const moreThumbsThanSpaceFor = imageData.value.length > maxRoomForThumbnails
            const moreThumbsToScrollFor = (thumbnailTotalCount.value - thumbnailsScrolledCount.value) > maxRoomForThumbnails
            return moreThumbsThanSpaceFor && moreThumbsToScrollFor
        })

        const thumbnailPaddingMargin = 16
        let thumbnailTotalCount = ref(0)
        let thumbnailHeight = 0
        const thumbnailScrollDistance = ref(0)
        const scrollDistanceStyle = computed(()=>{
            return `top: ${thumbnailScrollDistance.value}px`
        })
        const thumbnailsScrolledCount = ref(0)

        const scrollThumbnailsDown = function(){
            thumbnailScrollDistance.value = thumbnailScrollDistance.value - thumbnailHeight
            thumbnailsScrolledCount.value = Math.abs(thumbnailScrollDistance.value) / thumbnailHeight
        }

        const scrollThumbnailsUp = function(){
            thumbnailScrollDistance.value = thumbnailScrollDistance.value + thumbnailHeight
            thumbnailsScrolledCount.value = Math.abs(thumbnailScrollDistance.value) / thumbnailHeight
        }

        const loadImageForModal = (index) => {
            imageSelectedForModal.url = imageData.value[index].primaryUrl
            imageSelectedForModal.alt = imageData.value[index].alt
        }

        const inspectImage = (index) => {
            const documentBody = document.querySelector('body')
            loadImageForModal(index)
            modalActiveState.value = true
            documentBody.classList.add('no-scroll')
            documentBody.addEventListener('keyup', e => { 
                if (e.key === 'Escape') closeModal()
            })
        }

        const closeModal = () => {
            modalActiveState.value = false
            document.querySelector('body').classList.remove('no-scroll')
        }

        const selectImage = (e, index) => {
            if (e.type === 'touch' || e.type === 'click' || e.code === 'Space' || e.code === 'Enter' || e === 'customGlideTouch') {
                glide.go(`=${index}`)
                store.commit('productDetails/set_new_selected_image', index)
                loadImageForModal(index)
            }
        }

        const determineIndexForSelectingImageViaTouch = (glide) => {
            // fires each time glide slider is interacted with
            glide.on('run', (e) => {
                if (e.direction != '=') {
                    const currentSelectedImageIndex = imageData.value.indexOf(imageData.value.find(item => item.isSelected))
                    const directionMapping = e.direction === '>' ? +1 : -1
                    const newImageIndexToSelect = (currentSelectedImageIndex + directionMapping) > (imageData.value.length-1) ? 0 : (currentSelectedImageIndex + directionMapping)
                    selectImage('customGlideTouch', newImageIndexToSelect)
                }
            })
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        const productLabels = computed(() => getLabel('productLabels') || [])

        onMounted(() => {
            glide = new Glide('.glide', {
                type: 'slider',
                startAt: 0,
                perView: 1,
                keyboard: false
            }).mount()

            determineIndexForSelectingImageViaTouch(glide)
            
            window.dispatchEvent(new Event('resize')) // force glidejs logic to correctly update slide width

            const thumbnail = document.querySelectorAll('.nlx-product-detail-images__thumbnail-image')
            thumbnailTotalCount.value = thumbnail.length
            thumbnailHeight = thumbnail[0].clientHeight + thumbnailPaddingMargin
        })

        return {
            modalActiveState,
            imageData,
            imageSelectedForModal,
            productLabels,
            closeModal,
            getLabel,
            inspectImage,
            selectImage,
            showScrollDownButton,
            scrollThumbnailsDown,
            scrollDistanceStyle,
            showScrollUpButton,
            scrollThumbnailsUp
        }
    },
}
